import { SentryEnv } from '../SentryEnv';

export const getSentryEnv = () => {
	const { hostname } = window.location;
	const { MODE } = import.meta.env;

	if (hostname === 'localhost') {
		return SentryEnv.Local;
	}

	if (MODE === 'other') {
		return 'local';
	}

	return import.meta.env.VITE_SENTRY_ENVIRONMENT;
};
